/**
 * Formulaire heycup — reprise de la configuration produit.
 *
 * La fiche produit range la configuration en cours dans l'URL du bouton
 * « Demander un devis ». Ce module la relit ici et fait DEUX choses, qui vont
 * ensemble :
 *
 *   - il l'affiche, pour que le visiteur voie qu'il n'a rien à ressaisir ;
 *   - il la recopie dans des champs cachés, pour qu'elle parte réellement
 *     avec la demande.
 *
 * Faire l'un sans l'autre serait le pire des deux mondes : un client rassuré
 * par un récapitulatif que heycup ne recevrait jamais.
 */

import { Component } from '@theme/component';

/** Paramètres repris, dans l'ordre d'affichage. Tout le reste est ignoré. */
const REPRIS = [
  ['ref', 'Référence'],
  ['marquage', 'Marquage'],
  ['palier', 'Palier'],
  ['coloris', 'Coloris'],
  ['sku', 'SKU'],
  ['total', 'Estimation'],
];

class HeyFormulaire extends Component {
  connectedCallback() {
    super.connectedCallback();

    const params = new URLSearchParams(window.location.search);
    const entrees = [];
    for (const [cle, libelle] of REPRIS) {
      const valeur = params.get(cle);
      if (valeur) entrees.push([libelle, valeur]);
    }
    if (!entrees.length) return;

    this.#afficher(entrees);
    this.#recopier(entrees);
  }

  #afficher(entrees) {
    const { config, configListe } = this.refs;
    if (!config || !configListe) return;

    configListe.textContent = '';
    for (const [libelle, valeur] of entrees) {
      const dt = document.createElement('dt');
      dt.textContent = libelle;
      const dd = document.createElement('dd');
      dd.textContent = valeur;
      configListe.append(dt, dd);
    }
    config.hidden = false;
  }

  #recopier(entrees) {
    const { caches } = this.refs;
    if (!caches) return;

    caches.textContent = '';
    for (const [libelle, valeur] of entrees) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `contact[${libelle}]`;
      input.value = valeur;
      caches.append(input);
    }
  }
}

if (!customElements.get('hey-formulaire')) {
  customElements.define('hey-formulaire', HeyFormulaire);
}
